import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { ShowTableUser } from "../../../components/ShowTable";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import { SearchBar, Loader, ButtonModifier } from "../../../components";
import { Container, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Pagination,
  Button,
  ButtonGroup,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useDownloadExcel } from "react-export-table-to-excel";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import useScreenWidth from "../../../hooks/useScreenWidth";

const DaftarUser = () => {
  const ref = useRef(null);
  const tableRef = useRef(null);
  const { user, setting, dispatch } = useContext(AuthContext);
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const screenSize = useScreenWidth();

  const [isFetchError, setIsFetchError] = useState(false);
  const [kodeCabang, setKodeCabang] = useState("");
  const [userId, setUserId] = useState("");
  const [username, setUsername] = useState("");
  const [tipeUser, setTipeUser] = useState("");
  const [periode, setPeriode] = useState("");
  const [kodeKwitansi, setKodeKwitansi] = useState("");
  const [noTerakhir, setNoTerakhir] = useState("");
  const [coaKasir, setCoaKasir] = useState("");

  // Akses Master
  const [stok, setStok] = useState(false);
  const [supplier, setSupplier] = useState(false);
  const [mekanik, setMekanik] = useState(false);
  const [bukuBesar, setBukuBesar] = useState(false);
  const [area, setArea] = useState(false);
  const [customer, setCustomer] = useState(false);
  const [tipe, setTipe] = useState(false);
  const [warna, setWarna] = useState(false);
  const [jenisPembayaran, setJenisPembayaran] = useState(false);
  const [cabang, setCabang] = useState(false);

  // Akses Transaksi
  const [pembelian, setPembelian] = useState(false);
  const [returPembelian, setReturPembelian] = useState(false);
  const [pembayaranHutang, setPembayaranHutang] = useState(false);
  const [penjualan, setPenjualan] = useState(false);
  const [pembayaranPiutang, setPembayaranPiutang] = useState(false);
  const [mutasiStok, setMutasiStok] = useState(false);
  const [rekalkulasiStok, setRekalkulasiStok] = useState(false);

  // Akses Laporan
  const [laporanPembelian, setLaporanPembelian] = useState(false);
  const [laporanPenjualan, setLaporanPenjualan] = useState(false);
  const [laporanStok, setLaporanStok] = useState(false);
  const [laporanHutang, setLaporanHutang] = useState(false);
  const [laporanKas, setLaporanKas] = useState(false);

  // Finance
  const [kasMasuk, setKasMasuk] = useState(false);
  const [kasKeluar, setKasKeluar] = useState(false);
  const [bankMasuk, setBankMasuk] = useState(false);
  const [bankKeluar, setBankKeluar] = useState(false);

  // Accounting
  const [posting, setPosting] = useState(false);
  const [unposting, setUnposting] = useState(false);
  const [aktivitasBukuBesar, setAktivitasBukuBesar] = useState(false);
  const [neracaSaldo, setNeracaSaldo] = useState(false);
  const [labaRugi, setLabaRugi] = useState(false);
  const [neraca, setNeraca] = useState(false);
  const [jurnalUmum, setJurnalUmum] = useState(false);

  // Akses Utility
  const [profilUser, setProfilUser] = useState(false);
  const [daftarUser, setDaftarUser] = useState(false);
  const [tutupPeriode, setTutupPeriode] = useState(false);
  const [gantiPeriode, setGantiPeriode] = useState(false);
  const [settingAkses, setSettingAkses] = useState(false);

  const [previewPdf, setPreviewPdf] = useState(false);
  const [previewExcel, setPreviewExcel] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [users, setUser] = useState([]);
  const [usersPagination, setUsersPagination] = useState([]);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  useEffect(() => {
    if (user.tipeUser === "OWNER/DIREKSI") {
      getUsersAllCabangPagination();
    } else {
      getUsersPagination();
    }
    id && getUserById();
    ref.current?.scrollIntoView({ behavior: "smooth" });
  }, [id, page, searchTerm]);

  const getUsers = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${tempUrl}/usersPerCabang`, {
        tipeAdmin: user.tipeUser,
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      });
      setUser(response.data);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getUsersPagination = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${tempUrl}/usersPerCabangExceptOwnerPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        }
      );
      setUsersPagination(response.data.users);
      setPage(response.data.page);
      setPages(response.data.totalPage);
      setRows(response.data.totalRows);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getUsersAllCabang = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${tempUrl}/usersRebuild`, {
        tipeAdmin: user.tipeUser,
        _id: user.id,
        token: user.token,
      });
      setUser(response.data);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getUsersAllCabangPagination = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${tempUrl}/usersPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        }
      );
      setUsersPagination(response.data.users);
      setPage(response.data.page);
      setPages(response.data.totalPage);
      setRows(response.data.totalRows);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getUserById = async () => {
    if (id) {
      const response = await axios.post(`${tempUrl}/findUser/${id}`, {
        _id: user.id,
        token: user.token,
      });
      setUserId(response.data.id);
      setUsername(response.data.username);
      setTipeUser(response.data.tipeUser);
      setPeriode(response.data.tutupperiode.namaPeriode);
      setKodeKwitansi(response.data.kodeKwitansi);
      setNoTerakhir(response.data.noTerakhir);
      setKodeCabang(response.data.cabang);
      setCoaKasir(
        `${response.data.coa.kodeCOA} - ${response.data.coa.namaCOA}`
      );

      // Akses Master
      setStok(response.data.akses.stok);
      setSupplier(response.data.akses.supplier);
      setMekanik(response.data.akses.mekanik);
      setBukuBesar(response.data.akses.bukuBesar);
      setArea(response.data.akses.area);
      setCustomer(response.data.akses.customer);
      setTipe(response.data.akses.tipe);
      setWarna(response.data.akses.warna);
      setJenisPembayaran(response.data.akses.jenisPembayaran);
      setCabang(response.data.akses.cabang);

      // Akses Transaksi
      setPembelian(response.data.akses.pembelian);
      setReturPembelian(response.data.akses.returPembelian);
      setPembayaranHutang(response.data.akses.pembayaranHutang);
      setPenjualan(response.data.akses.penjualan);
      setPembayaranPiutang(response.data.akses.pembayaranPiutang);
      setMutasiStok(response.data.akses.mutasiStok);
      setRekalkulasiStok(response.data.akses.rekalkulasiStok);

      // Akses Laporan
      setLaporanPembelian(response.data.akses.laporanPembelian);
      setLaporanPenjualan(response.data.akses.laporanPenjualan);
      setLaporanStok(response.data.akses.laporanStok);
      setLaporanHutang(response.data.akses.laporanHutang);
      setLaporanKas(response.data.akses.laporanKas);

      // Finance
      setKasMasuk(response.data.akses.kasMasuk);
      setKasKeluar(response.data.akses.kasKeluar);
      setBankMasuk(response.data.akses.bankMasuk);
      setBankKeluar(response.data.akses.bankKeluar);

      // Accounting
      setPosting(response.data.akses.posting);
      setUnposting(response.data.akses.unposting);
      setAktivitasBukuBesar(response.data.akses.aktivitasBukuBesar);
      setNeracaSaldo(response.data.akses.neracaSaldo);
      setLabaRugi(response.data.akses.labaRugi);
      setNeraca(response.data.akses.neraca);
      setJurnalUmum(response.data.akses.jurnalUmum);

      // Akses Utility
      setProfilUser(response.data.akses.profilUser);
      setDaftarUser(response.data.akses.daftarUser);
      setTutupPeriode(response.data.akses.tutupPeriode);
      setGantiPeriode(response.data.akses.gantiPeriode);
      setSettingAkses(response.data.akses.setting);
    }
  };

  const deleteUser = async (id) => {
    setLoading(true);
    try {
      let findTransactionDataByUserId = await axios.post(
        `${tempUrl}/transactionDataByUserId`,
        {
          userId: userId,
          _id: user.id,
          token: user.token,
        }
      );

      if (findTransactionDataByUserId.data === true) {
        alert(
          "User tidak bisa dihapus karena sudah pernah melakukan penginputan data. Harap bisa diubah passwordnya secara acak agar tidak bisa diakses lagi!"
        );
        navigate(`/daftarUser/${id}/edit`);
        return;
      } else {
        await axios.post(`${tempUrl}/users/deleteUser/${id}`, {
          tipeAdmin: user.tipeUser,
          _id: user.id,
          token: user.token,
        });
      }

      setSearchTerm("");
      setUsername("");
      setTipeUser("");
      setPeriode("");
      setKodeKwitansi("");
      setNoTerakhir("");
      setKodeCabang("");

      if (user.id == id) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      } else {
        navigate("/daftarUser");
      }
    } catch (error) {
      if (error.response.data.message.includes("foreign key")) {
        alert(`${username} tidak bisa dihapus karena sudah ada data!`);
      }
    }
    setLoading(false);
  };

  const downloadPdf = () => {
    var date = new Date();
    var current_date =
      date.getDate().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      "-" +
      (date.getMonth() + 1).toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      "-" +
      date.getFullYear();
    var current_time =
      date.getHours().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getMinutes().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getSeconds().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
    const doc = new jsPDF();
    doc.setFontSize(10);
    doc.text(
      `${setting.namaPerusahaan} - ${setting.kabupatenPerusahaan}`,
      15,
      10
    );
    doc.text(`${setting.alamatPerusahaan}`, 15, 15);
    doc.setFontSize(14);
    doc.text(`Daftar User`, 85, 30);
    doc.setFontSize(8);
    doc.text(
      `Dicetak Oleh: ${user.username} | Tanggal : ${current_date} | Jam : ${current_time}`,
      15,
      290
    );
    doc.autoTable({
      html: "#table",
      startY: doc.pageCount > 1 ? doc.autoTableEndPosY() + 20 : 45,
      headStyles: {
        fillColor: [117, 117, 117],
        color: [0, 0, 0],
      },
      styles: {
        fontSize: 8,
      },
    });
    window.open(URL.createObjectURL(doc.output("blob")));
  };

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Daftar User",
    sheet: "DaftarUser",
  });

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const textRightSmall = {
    textAlign: screenSize >= 650 && "right",
    fontSize: "14px",
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Container ref={ref}>
      <h3>Utility</h3>
      <h5 style={{ fontWeight: 400 }}>Daftar User</h5>
      <Box sx={downloadButtons}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button
            color="primary"
            startIcon={<SearchIcon />}
            onClick={() => {
              if (user.tipeUser === "OWNER/DIREKSI") {
                getUsersAllCabang();
              } else {
                getUsers();
              }
              setPreviewPdf(!previewPdf);
              setPreviewExcel(false);
            }}
          >
            PDF
          </Button>
          <Button
            color="secondary"
            startIcon={<SearchIcon />}
            onClick={() => {
              if (user.tipeUser === "OWNER/DIREKSI") {
                getUsersAllCabang();
              } else {
                getUsers();
              }
              setPreviewExcel(!previewExcel);
              setPreviewPdf(false);
            }}
          >
            Excel
          </Button>
        </ButtonGroup>
      </Box>
      {previewPdf && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={() => downloadPdf()}
          >
            CETAK
          </Button>
          <table class="table" id="table">
            <thead>
              <tr>
                <th>Username</th>
                <th>Tipe User</th>
                <th>Periode</th>
                <th>Kode Kwitansi</th>
                <th>No Terakhir</th>
                <th>Cabang</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user, index) => (
                <tr key={user.id}>
                  <td>{user.username}</td>
                  <td>{user.tipeUser}</td>
                  <td>{user.tutupperiode.namaPeriode}</td>
                  <td>{user.kodeKwitansi}</td>
                  <td>{user.noTerakhir}</td>
                  <td>
                    {user.cabang.id} - {user.cabang.namaCabang}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div>
        {previewExcel && (
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={onDownload}
          >
            EXCEL
          </Button>
        )}
        <table ref={tableRef}>
          {previewExcel && (
            <tbody>
              <tr>
                <th>Username</th>
                <th>Tipe User</th>
                <th>Periode</th>
                <th>Kode Kwitansi</th>
                <th>No Terakhir</th>
                <th>Cabang</th>
              </tr>
              {users.map((user, index) => (
                <tr key={user.id}>
                  <td>{user.username}</td>
                  <td>{user.tipeUser}</td>
                  <td>{user.tutupperiode.namaPeriode}</td>
                  <td>{user.kodeKwitansi}</td>
                  <td>{user.noTerakhir}</td>
                  <td>
                    {user.cabang.id} - {user.cabang.namaCabang}
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </div>
      <Box sx={buttonModifierContainer}>
        <ButtonModifier
          id={id}
          kode={id}
          addLink={`/daftarUser/tambahUser`}
          editLink={`/daftarUser/${id}/edit`}
          deleteUser={deleteUser}
          nameUser={username}
        />
      </Box>
      {id && (
        <Container>
          <hr />
          <Form>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        Username :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control value={username} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        Tipe User :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control value={tipeUser} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        Periode :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control value={periode} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        Cabang :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          value={`${kodeCabang.id} - ${kodeCabang.namaCabang}`}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>

              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRightSmall}>
                        Kode Kwitansi :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control value={kodeKwitansi} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        No Terakhir :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control value={noTerakhir} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        COA Kasir :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control value={coaKasir} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
          </Form>
          {user.tipeUser !== "ADMIN" && (
            <>
              <Typography variant="h5" sx={[labelInput, spacingTop]}>
                Hak Akses User
              </Typography>
              <Box sx={showDataContainer}>
                <Box sx={showDataWrapper}>
                  <Typography variant="p" sx={[spacingTop]}>
                    Master
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={bukuBesar} disabled />}
                      label="Buku Besar"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={area} disabled />}
                      label="Area"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={stok} disabled />}
                      label="Stok"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={supplier} disabled />}
                      label="Supplier"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={mekanik} disabled />}
                      label="Mekanik"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={customer} disabled />}
                      label="Customer"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={tipe} disabled />}
                      label="Tipe"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={warna} disabled />}
                      label="Warna"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={jenisPembayaran} disabled />}
                      label="Jenis Pembayaran"
                    />
                  </FormGroup>
                  {/* <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={cabang} disabled />}
                      label="Cabang"
                    />
                  </FormGroup> */}
                  <Typography variant="p" sx={[spacingTop]}>
                    Transaksi
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={pembelian} disabled />}
                      label="Pembelian"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={returPembelian} disabled />}
                      label="Retur Pembelian"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={pembayaranHutang} disabled />}
                      label="Pembayaran Hutang"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={penjualan} disabled />}
                      label="Penjualan / Servis"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox checked={pembayaranPiutang} disabled />
                      }
                      label="Penerimaan Piutang"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={mutasiStok} disabled />}
                      label="Mutasi Stok"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={rekalkulasiStok} disabled />}
                      label="Rekalkulasi Stok"
                    />
                  </FormGroup>
                  <Typography variant="p" sx={[spacingTop]}>
                    Laporan
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={laporanPembelian} disabled />}
                      label="Laporan Pembelian"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={laporanPenjualan} disabled />}
                      label="Laporan Penjualan"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={laporanStok} disabled />}
                      label="Laporan Stok"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={laporanHutang} disabled />}
                      label="Laporan Hutang"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={laporanKas} disabled />}
                      label="Laporan Kas"
                    />
                  </FormGroup>
                </Box>
                <Box sx={[showDataWrapper, secondWrapper]}>
                  <Typography variant="p" sx={[spacingTop]}>
                    Finance
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={kasMasuk} disabled />}
                      label="Kas Masuk"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={kasKeluar} disabled />}
                      label="Kas Keluar"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={bankMasuk} disabled />}
                      label="Bank Masuk"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={bankKeluar} disabled />}
                      label="Bank Keluar"
                    />
                  </FormGroup>
                  <Typography variant="p" sx={[spacingTop]}>
                    Accounting
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={posting} disabled />}
                      label="Posting"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={unposting} disabled />}
                      label="Unposting"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox checked={aktivitasBukuBesar} disabled />
                      }
                      label="Aktivitas Buku Besar"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={neracaSaldo} disabled />}
                      label="Neraca Saldo"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={labaRugi} disabled />}
                      label="Laba Rugi"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={neraca} disabled />}
                      label="Neraca"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={jurnalUmum} disabled />}
                      label="Jurnal Umum"
                    />
                  </FormGroup>
                  <Typography variant="p" sx={[spacingTop]}>
                    Utility
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={profilUser} disabled />}
                      label="Profil User"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={daftarUser} disabled />}
                      label="Daftar User"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={tutupPeriode} disabled />}
                      label="Tutup Periode"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={gantiPeriode} disabled />}
                      label="Ganti Periode"
                    />
                  </FormGroup>
                  {user.tipeUser === "OWNER/DIREKSI" && (
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox checked={settingAkses} disabled />}
                        label="Setting"
                      />
                    </FormGroup>
                  )}
                </Box>
              </Box>
            </>
          )}
        </Container>
      )}
      <hr />
      <Form onSubmit={searchData}>
        <Box sx={searchBarContainer}>
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disableElevation
          >
            Cari
          </Button>
        </Box>
      </Form>
      <Box sx={tableContainer}>
        <ShowTableUser currentPosts={usersPagination} />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Container>
  );
};

export default DaftarUser;

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const showDataContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const checkboxTitle = {
  marginBottom: 0,
};

const secondCheckboxTitle = {
  marginTop: 15,
  marginBottom: 0,
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const labelInput = {
  fontWeight: "600",
  marginLeft: 1,
};

const spacingTop = {
  mt: 4,
};
